import { Component, ElementRef, inject, input, output, ViewChild } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { BaseConfigurableComponent } from "@app/base-config.component";
import { PhoneMaskDirective } from "@app/directive/phone-mask.directive";
import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "@app/models/question-base";
import { BranchService } from "@app/services/branch/branch.service";
import { CategoriesService } from "@app/services/categories/categories.service";

@Component({
  selector: 'afcu-input',
  standalone: true,
  imports: [ReactiveFormsModule, PhoneMaskDirective],
  templateUrl: './question.component.html',
  styleUrl: './question.component.css'
})

export class QuestionComponent extends BaseConfigurableComponent{

  inputType : typeof InputType = InputType
  @ViewChild('searchQuery', { static: false }) searchQuery!: ElementRef;
  
  protected categoryService = inject( CategoriesService );
  protected branchService = inject( BranchService );

  question = input.required<QuestionBase<string>>();
  form = input.required<FormGroup>();

  externalFunction = output<{ function: string; value: string; }>()

  searchQueryType = input<string>()

  bluredOut = false

  togglePassword = false

  error = {
    min: false,
    max: false,
    pattern: false
  }

  constructor() {
    super('search')
  }

  search(val: string){
    if(this.searchQueryType() == 'service')
      this.categoryService.searchQuery.set(val)
    else if (this.searchQueryType() == 'branch'){
      this.branchService.searchQuery.set(val)
    }
  }

  onChange(val:Event) {
    const target = val.target as HTMLInputElement
    this.externalFunction.emit({
      function: this.question().externalFunction!,
      value: (target.value !== 'on') ? target.value : target.id
    })
  }

  focus() {
    this.bluredOut = false
  }

  inputChange() {
    
    const errors = this.form().get(this.question().key)?.errors
    if (errors){
      this.error.min = ('minlength' in errors) 
      this.error.max = ('maxlength' in errors)
      this.error.pattern = ('pattern' in errors)

      if (this.error.pattern && this.bluredOut)
        this.form().get(this.question().key)?.setErrors({ 'error': true})
      else if (this.error.max)
        this.form().get(this.question().key)?.setErrors({ 'error': true})
    }

  }

  checkMe() {
    this.form().get(this.question().key)?.setValue(!this.form().get(this.question().key)?.value)
  }

  resetSearch() {
    this.searchQuery.nativeElement.value = ''
    this.search('')
  }

  blurOut() {
    this.bluredOut = true
    const errors = this.form().get(this.question().key)?.errors
    
    if (errors){
      this.error.min = ('minlength' in errors)
      this.error.max = ('maxlength' in errors)
      this.error.pattern = ('pattern' in errors) 

      if (!this.question().phoneMask){
        if (this.error.pattern && this.bluredOut){
          this.form().get(this.question().key)?.setErrors({ 'error': true})
        }
      }
      
      if (this.error.min){
        this.form().get(this.question().key)?.setErrors({ 'error': true })
      }

      if (this.error.max){
        if(this.question().phoneMask){
          const trim = errors['pattern'].actualValue.replaceAll('-', '')

          if (trim.length !== errors['maxlength'].requiredLength){
            this.form().get(this.question().key)?.setErrors({ 'error': true })
          }

        }else {
          this.form().get(this.question().key)?.setErrors({ 'error': true })
        }
      }

      if (this.error.pattern && !this.question().phoneMask)  {
        this.form().get(this.question().key)?.setErrors({ 'error': true })
      } else {
        if (this.question().required && this.form().get(this.question().key)?.value.trim() == ''){
          this.form().get(this.question().key)?.setErrors({ 'error': this.form().get(this.question().key)?.value.trim() == '' })
        }
      }
    }
  }

  setErrorInput(event: any) {
    if (!this.form().controls[this.question().key].valid){
      this.form().get(this.question().key)?.setErrors({ 'error': !this.form().controls[this.question().key].valid })
    }
  }

  onKeyUpNumericOnly(event: KeyboardEvent): void {
    const isNumber = /^[0-9]$/.test(event.key);
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
    ];
    
    if (!isNumber) {
      if (!allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    }
    
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');
    this.form().get(this.question().key)?.setValue(input.value, { emitEvent: false });
  }

  get isValid() {
    return this.form().controls[this.question().key].valid;
  }

  get isError() {
    return this.form().controls[this.question().key].getError('error')
  }
  
}
